var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../app';
import { Component, SvgPath } from '../../lib/dom';
import { OrangeButton } from '../../lib/components/Button/Button';
import { drawBackground } from './drawBackground';
import { throttle } from '../../lib/utils';
import { CUP_PATH, VIDEO_ICON_PATH } from '../../app/const/svg';
import { PHRASES, t } from '../../translate';
import { CANCEL_MOVES_FEATURE } from '../../app/const/features';
import './EndGameScreen.less';
import { calcMaxEndGameScreenWidth } from '../Game/src/geometry/calcMaxEndGameScreenWidth';
var EndGameScreen = /** @class */ (function (_super) {
    __extends(EndGameScreen, _super);
    function EndGameScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'EndGameScreen';
        _this.opened = false;
        _this.onClick = function (cancel) {
            _this.hide();
            _this.props.onClick(cancel);
        };
        _this.onResize = throttle(function () {
            if (_this.el.valueOf().style.display !== 'block') {
                return;
            }
            var w = window.innerWidth, h = window.innerHeight;
            var width = calcMaxEndGameScreenWidth();
            _this.preview.valueOf().style.width = width + 'px';
            _this.preview.valueOf().style.marginLeft = Math.ceil((w - width) / 2) + 'px';
            var height = _this.preview.valueOf().getBoundingClientRect().height;
            var top = Math.ceil((window.innerHeight - height) / 2);
            _this.preview.valueOf().style.top = top + 'px';
            var bgSize = Math.floor(Math.sqrt(w * w + h * h));
            var halfSize = Math.floor(bgSize / 2);
            var style = _this.bg.valueOf().style;
            style.width = bgSize + 'px';
            style.height = bgSize + 'px';
            style.marginLeft = -halfSize + 'px';
            style.marginTop = -halfSize + 'px';
            style.backgroundImage = drawBackground(bgSize);
        }, 50);
        var userClassName = _this.props.className;
        var className = userClassName ? '& ' + userClassName : '&';
        _this.el = _this.DIV({ className: className, style: { display: 'none' } }, [
            (_this.bg = _this.DIV('&-background')),
            (_this.title = _this.DIV('&-title')),
            _this.DIV('&-count', [
                new SvgPath({ viewBox: '0 0 489.4 489.4', path: [CUP_PATH] }),
                (_this.count = _this.DIV({}, ['000'])),
            ]),
            (_this.preview = _this.DIV('&-preview-w')),
            _this.DIV('&-button-w', [
                (_this.newGameBtn = new OrangeButton({
                    className: CANCEL_MOVES_FEATURE ? '' : 'ScaleAnimated',
                    onClick: function () { return _this.onClick(false); },
                }, [t(PHRASES.New_Game)])),
                CANCEL_MOVES_FEATURE
                    ? (_this.cancelBtn = new OrangeButton({
                        className: _this.parseClassName('&__rwBtn ') + (CANCEL_MOVES_FEATURE ? 'ScaleAnimated' : ''),
                        onClick: function () { return _this.onClick(true); },
                    }, 
                    // TODO t(...)
                    ['Отмена хода', new SvgPath({ viewBox: '0 0 58 58', path: VIDEO_ICON_PATH, fill: '#c92200' })]))
                    : null,
            ]),
        ]);
        window.addEventListener('resize', _this.onResize);
        _this.onResize();
        App.emitter.on('lang', function () {
            _this.newGameBtn.valueOf().innerHTML = t(PHRASES.New_Game);
        });
        return _this;
    }
    EndGameScreen.prototype.show = function (count, preview, isRecord, isAbsoluteRecord, canCancel) {
        var _this = this;
        if (this.cancelBtn) {
            this.cancelBtn.valueOf().style.display = canCancel ? 'block' : 'none';
        }
        this.toggleClassName('&_win', isRecord);
        this.count.valueOf().innerText = String(count);
        if (this.preview.valueOf().firstChild) {
            this.preview.valueOf().removeChild(this.preview.valueOf().firstChild);
        }
        this.preview.valueOf().appendChild(preview);
        if (isAbsoluteRecord) {
            this.title.text("".concat(t(PHRASES.HIGH_SCORE_1), " ").concat(t(PHRASES.HIGH_SCORE_2)));
        }
        else if (isRecord) {
            this.title.text("".concat(t(PHRASES.HIGH_SCORE_TODAY_1), " ").concat(t(PHRASES.HIGH_SCORE_TODAY_2)));
        }
        else {
            this.title.text(t(PHRASES.Score));
        }
        var bg = App.themes.get().bg;
        this.preview.valueOf().style.backgroundColor = bg;
        setTimeout(function () {
            _this.el.valueOf().style.display = 'block';
            _this.opened = true;
            _this.onResize();
        }, 50);
    };
    EndGameScreen.prototype.redraw = function (preview) {
        this.preview.valueOf().innerHTML = '';
        this.preview.valueOf().appendChild(preview);
        this.onResize();
    };
    EndGameScreen.prototype.hide = function () {
        var _this = this;
        this.el.valueOf().style.display = 'none';
        setTimeout(function () { return (_this.opened = false); }, 100);
    };
    return EndGameScreen;
}(Component));
export { EndGameScreen };
